import React from 'react';
import classes from './styles.module.scss';
import { DefaultUserIcon } from '../Icons';

interface IntercomCardProps {
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const IntercomCard: React.FC<IntercomCardProps> = ({ onClick }) => {
  return (
    <div
      className={classes['intercom-card']}
      role="button"
      tabIndex={0}
      onClick={onClick}
    >
      <div className={classes['intercom-card__avatar-wrapper']}>
        <DefaultUserIcon width={35} height={35} />
      </div>

      <div className={`${classes['intercom-card__content']} sendbird-label`}>
        <div className={classes['intercom-card__header']}>
          <span className={classes['intercom-card__title']}>
            Customer Support
          </span>
        </div>
        <div className={classes['intercom-card__message']}>
          <span>
            For support-related queries, please click here to proceed forward.
          </span>
        </div>
      </div>
    </div>
  );
};

export default IntercomCard;
